import { useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Fade,
  Grid,
  Link,
  ListItemText,
  Skeleton,
  Stack,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { formatDateTime, formatearFecha } from '../../../@iosper/utils/Format';
import { QRCodeSVG } from 'qrcode.react';
import { useAfiliados } from '../../Afiliados/AfiliadosProvider';
import { useInfoAfiliado } from '../../Afiliados/InfoAfiliadoProvider';
import { useTheme } from '@emotion/react';
import logo from '../../../assets/images/logo-small.png';
import { Link as RouterLink } from 'react-router-dom';
import CountDown from '../../Common/CountDown';
import { generarTokenCredencial } from '../../../services/Afiliado/Afiliado';
import {
  AccountCircleOutlined,
  BadgeOutlined,
  BadgeRounded,
  Close as CloseIcon,
  Person2Outlined,
  Person2Rounded,
  PersonOutlineRounded,
  Share as ShareIcon,
} from '@mui/icons-material';
import ShareButton from '../../Common/ShareButton';
import { CarouselMobile } from '../../Common/Mobile/CarouselMobile';

const buildValidarCredencialUrl = (data) => {
  // Codificar objeto a Base64 de forma segura
  const json = JSON.stringify(data);
  const base64 = btoa(json);
  // Obtener la URL base del sitio actual
  const baseUrl = window.location.origin;
  // Construir la URL completa
  const url = `${baseUrl}/validar-credencial/${base64}`;
  return url;
};

const DrawerDataField = ({ label, data, style = {} }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, alignItems: 'baseline', ...style }}>
      <Typography variant='body' fontWeight={700}>
        {label}
      </Typography>
      <ListItemText primary={data} />
    </Box>
  );
};

export const AfiliadoCardGrupoSliderMobile = () => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const { afiliados } = useAfiliados();
  const { infoAfiliado } = useInfoAfiliado();
  const [open, setOpen] = useState(false);
  const [afiliadoSelected, setAfiliadoSelected] = useState(null);
  const [tokenActual, setTokenActual] = useState(null);
  const [caducado, setCaducado] = useState(false);
  const [fechaCreacionToken, setFechaCreacionToken] = useState(null);

  const dataAfiliados =
    Array.isArray(afiliados) && afiliados.length > 0
      ? afiliados.map((afiliado) => ({
          idAfiliado: afiliado?.afiliado?.idAfiliado,
          nombre: afiliado?.personaFisica?.nombre,
          apellido: afiliado?.personaFisica?.apellido,
          documento: afiliado?.personaFisica?.numeroDocumentoString,
          tipoDocumento: afiliado?.tipoDocumento?.descripcion,
          cuilCuit: afiliado?.persona?.cuilCuitFormateado,
          fechaNacimiento: afiliado?.personaFisica?.fechaNacimiento,
          localidad: afiliado?.localidad?.descripcion,
          provincia: afiliado?.provincia?.descripcion,
          tipoAfiliado: afiliado?.tipoAfiliado?.descripcion,
          relacionTitularAdherente: afiliado?.relacionTitularAdherente?.descripcion,
          numeroAfiliado: afiliado?.afiliado?.numeroAfiliadoFormateado,
          derivacion: !afiliado?.derivacion
            ? null
            : {
                descripcionTipoDerivacion: afiliado?.derivacion?.descripcionTipoDerivacion,
                obraSocialDescripcion: afiliado?.derivacion?.obraSocialDescripcion,
                obraSocialSigla: afiliado?.derivacion?.sigla,
                obraSocialProvincia: afiliado?.derivacion?.provinciaDescripcion,
                fechaDesde: afiliado?.derivacion?.fechaDesde,
                fechaHasta: afiliado?.derivacion?.fechaHasta,
              },
        }))
      : [];

  const handleClickOpen = async (afiliado) => {
    setAfiliadoSelected(afiliado);
    const getToken = await generarTokenCredencial(afiliado);
    if (getToken?.token && getToken?.fechaCreacion) {
      setTokenActual(getToken.token);
      setFechaCreacionToken(getToken.fechaCreacion);
      setOpen(true);
    }
  };

  const handleGenerateQR = async () => {
    const getToken = await generarTokenCredencial(afiliadoSelected);
    if (getToken?.token && getToken?.fechaCreacion) {
      setTokenActual(getToken.token);
      setFechaCreacionToken(getToken.fechaCreacion);
      setCaducado(false);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onCaducado = () => {
    setCaducado(true);
    setFechaCreacionToken(null);
  };

  return (
    <>
      {(!dataAfiliados || !Array.isArray(dataAfiliados) || dataAfiliados.length <= 0) && (
        <CarouselMobile disableButtonsInMobile={true}>
          {[1, 2, 3].map((item) => (
            <Card
              sx={{
                height: '100%',
                borderRadius: 4,
                overflow: 'hidden',
                boxShadow: '0 2px 4px rgba(0,0,0,0.02), 0 10px 20px rgba(0,0,0,0.06)',
              }}
              key={item}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  justifyContent: 'flex-start',
                  height: '100%',
                }}
              >
                <CardContent style={{ padding: '16px 24px', width: '100%' }}>
                  <Skeleton variant='text' width={150} height={24} />
                  <Stack
                    direction='row'
                    justifyContent='space-between'
                    alignItems='center'
                    spacing={1}
                  >
                    <Skeleton variant='rectangular' width={100} height={24} />
                    <Skeleton variant='rectangular' width={100} height={24} />
                  </Stack>
                </CardContent>
              </Box>
            </Card>
          ))}
          {/* <Skeleton
            variant='rectangular'
            sx={{ width: '100%', height: '300px', borderRadius: '10px' }}
          /> */}
        </CarouselMobile>
      )}
      {dataAfiliados?.length > 0 && (
        <CarouselMobile disableButtonsInMobile={true}>
          {dataAfiliados.map((afiliado) => (
            <Card
              sx={{
                height: '100%',
                borderRadius: 4,
                overflow: 'hidden',
                // boxShadow: '0 8px 24px rgba(0, 75, 135, 0.08)',
                boxShadow: '0 2px 4px rgba(0,0,0,0.02), 0 10px 20px rgba(0,0,0,0.06)',
              }}
              key={afiliado?.idAfiliado}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  justifyContent: 'flex-start',
                  height: '100%',
                }}
              >
                <CardContent style={{ padding: '16px 24px', width: '100%' }}>
                  <Typography mb={1} variant='button' component='h2' fontWeight={'600'}>
                    {`${afiliado?.apellido}, ${afiliado?.nombre}` || ''}
                  </Typography>
                  {/* <Typography
                    mb={2}
                    variant='body1'
                    color='textSecondary'
                    component='h3'
                    fontFamily={'monospace, sans-serif'}
                  >
                    {afiliado?.numeroAfiliado?.replace(/-/g, ' ')}
                  </Typography> */}
                  <Stack
                    direction='row'
                    justifyContent='space-between'
                    alignItems='center'
                    spacing={1}
                  >
                    <Link
                      underline='none'
                      onClick={() => handleClickOpen(afiliado)}
                      sx={{ display: 'flex', alignItems: 'center', gap: '7px' }}
                      fontWeight={'500'}
                    >
                      <BadgeOutlined/> Credencial
                    </Link>

                    {infoAfiliado?.afiliado?.idAfiliado === afiliado?.idAfiliado && (
                      <Link
                        underline='none'
                        component={RouterLink}
                        to='/perfil'
                        sx={{ display: 'flex', alignItems: 'center', gap: '7px' }}
                        fontWeight={'500'}
                      >
                        <PersonOutlineRounded /> Perfil
                      </Link>
                    )}
                    {infoAfiliado?.afiliado?.idAfiliado !== afiliado?.idAfiliado && (
                      <Link
                        underline='none'
                        component={RouterLink}
                        to={`/ver-afiliado/${afiliado?.idAfiliado}`}
                        sx={{ display: 'flex', alignItems: 'center', gap: '7px' }}
                        fontWeight={'500'}
                      >
                        <PersonOutlineRounded /> Afiliado
                      </Link>
                    )}
                  </Stack>
                </CardContent>
              </Box>
            </Card>
          ))}
        </CarouselMobile>
      )}

      {afiliadoSelected && (
        <Dialog
          fullScreen={fullScreen}
          open={open}
          onClose={handleClose}
          aria-labelledby='responsive-dialog-title'
        >
          <DialogTitle id='responsive-dialog-title' margin={2} justifyContent={'center'}>
            Credencial Electrónica
          </DialogTitle>
          <DialogContent>
            <DialogContentText display={'flex'} alignItems={'center'} justifyContent={'center'}>
              {caducado && (
                <Fade
                  in={caducado}
                  style={{
                    transitionDelay: caducado ? '800ms' : '0ms',
                  }}
                  unmountOnExit
                >
                  <Button onClick={handleGenerateQR} sx={{ m: 2 }}>
                    Volver a generar QR
                  </Button>
                </Fade>
              )}
              {!caducado && (
                <Fade
                  in={!caducado}
                  style={{
                    transitionDelay: !caducado ? '800ms' : '0ms',
                  }}
                  unmountOnExit
                >
                  <Box>
                    <QRCodeSVG
                      value={buildValidarCredencialUrl({
                        token: tokenActual,
                        idAfiliado: afiliadoSelected?.idAfiliado,
                      })}
                      size={256}
                      imageSettings={{
                        src: logo,
                        x: undefined,
                        y: undefined,
                        height: 48,
                        width: 48,
                        opacity: 1,
                        excavate: true,
                      }}
                    />
                  </Box>
                </Fade>
              )}
            </DialogContentText>

            <Grid
              container
              display={'flex'}
              flexDirection='column'
              alignItems='center'
              px={2}
              pt={3}
              pb={0}
              gap={1}
            >
              <Typography variant='subtitle2' align='justify' sx={{ mx: { md: 4, xs: 0 } }}>
                El QR{' '}
                {fechaCreacionToken ? `se generó el ${formatDateTime(fechaCreacionToken)} y ` : ''}
                estará DISPONIBLE por 5 minutos, para que puedas compartirlo.
              </Typography>

              {!caducado && (
                <Fade
                  in={!caducado}
                  style={{
                    transitionDelay: !caducado ? '800ms' : '0ms',
                  }}
                  unmountOnExit
                >
                  <Typography
                    variant='caption'
                    fontSize={14}
                    fontWeight={'600'}
                    textAlign={'center'}
                  >
                    El código QR caducará en <br></br>{' '}
                    <CountDown minutes={5} onCaducado={onCaducado} />
                  </Typography>
                </Fade>
              )}
            </Grid>

            <Grid container spacing={0} sx={{ p: 2 }}>
              <Grid item xs={12}>
                <DrawerDataField
                  label='Afiliado'
                  data={`${afiliadoSelected?.apellido}, ${afiliadoSelected?.nombre}`}
                />
              </Grid>
              <Grid item xs={12}>
                <DrawerDataField label='Cuit/Cuil' data={afiliadoSelected?.cuilCuit} />
              </Grid>
              <Grid item xs={12}>
                <DrawerDataField
                  label='Fecha Nacimiento'
                  data={formatearFecha(afiliadoSelected?.fechaNacimiento, 'dd/mm/yyyy')}
                />
              </Grid>
              <Grid item xs={12}>
                <DrawerDataField
                  label='Residencia'
                  data={`${afiliadoSelected?.localidad}, ${afiliadoSelected?.provincia}`}
                />
              </Grid>
              <Grid item xs={12}>
                <DrawerDataField
                  label='Relación'
                  data={afiliadoSelected?.relacionTitularAdherente}
                />
              </Grid>
              <Grid item xs={12}>
                <DrawerDataField label='Tipo Afiliado' data={afiliadoSelected?.tipoAfiliado} />
              </Grid>
              {afiliadoSelected?.derivacion && (
                <>
                  <Grid item xs={12} my={2}>
                    <Typography variant='body2' fontSize={18}>
                      Afiliado Derivado
                    </Typography>
                    <Divider />
                  </Grid>
                  <Grid item xs={12}>
                    <DrawerDataField
                      label='Tipo Derivación'
                      data={afiliadoSelected?.derivacion?.descripcionTipoDerivacion}
                      style={{ flexDirection: { xs: 'column', sm: 'row' }, gap: { xs: 0, sm: 1 } }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <DrawerDataField
                      label='Destino'
                      data={`${afiliadoSelected?.derivacion?.obraSocialDescripcion || ''} ${
                        afiliadoSelected?.derivacion?.obraSocialSigla
                          ? '(' + afiliadoSelected.derivacion.obraSocialSigla + ')'
                          : ''
                      } - ${afiliadoSelected?.derivacion?.obraSocialProvincia || ''}`}
                      style={{ flexDirection: { xs: 'column', sm: 'row' }, gap: { xs: 0, sm: 1 } }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <DrawerDataField
                      label='Desde'
                      data={formatearFecha(afiliadoSelected?.derivacion?.fechaDesde, 'dd/mm/yyyy')}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <DrawerDataField
                      label='Hasta'
                      data={formatearFecha(afiliadoSelected?.derivacion?.fechaHasta, 'dd/mm/yyyy')}
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </DialogContent>
          <DialogActions sx={{ m: 2 }}>
            <Button
              variant='contained'
              color='neutral'
              onClick={handleClose}
              autoFocus
              startIcon={<CloseIcon />}
            >
              Cerrar
            </Button>
            <ShareButton
              title='OSER - Credencial Electrónica'
              text={`Hola, este es el enlace para visualizar la credencial electrónica del afiliado ${afiliadoSelected?.apellido}, ${afiliadoSelected?.nombre}. Disponible por 5 minutos.`}
              url={buildValidarCredencialUrl({
                token: tokenActual,
                idAfiliado: afiliadoSelected?.idAfiliado,
              })}
              buttonProps={{
                variant: 'contained',
                color: 'primary',
                startIcon: <ShareIcon />,
                disabled: caducado,
              }}
            >
              Compartir
            </ShareButton>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};
